import { push } from "connected-react-router";
import React, { useState } from "react";
import { useDispatch } from "react-redux";
import { ROUTE_PATH } from "../../../app/constants";
import { Button, Header, Paragraph, ErrorMark } from "../../../components/RegularComponents";

export const SelectTypeCompany = (props) => {
  const dispatch = useDispatch();

  const [route, setRoute] = useState("");
  const [validationError, setValidationError] = useState(false);

  //const [applicationSaveError, setApplicationSaveError] = useState(false);

  const handleContinue = () => {

    if(!route){
        setValidationError(true);
        return;
    }

    let path = ""

    switch (route){
      case "corporation":
        path = `${ROUTE_PATH.MA_APP}${ROUTE_PATH.MA_IS_BUSINESS_INCORPORATED}`;
        break;
      case "partnership":
        path = `${ROUTE_PATH.MA_APP}${ROUTE_PATH.MA_IS_BUSINESS_UNDER_LAW}`;
        break;
      case "soleProprietor":
        path = `${ROUTE_PATH.MA_APP}${ROUTE_PATH.MA_IS_RESIDENT_CANADA}`;
        break;
      default:
        break;
    }


    if(route){
        dispatch(push(path));
    }
  };

  return (
    <div className="container">
      {/* Title */}

      <div className="row">
        <div className="col-lg-8">
          <Header
            id="select-type-company-header"
            header={"Select your type of business"}
          />
          <Paragraph
            id="select-type-company-text"
            text={['Choose an option that describes your business structure.']}
          />
        </div>
      </div>


      <div className={"row"}>
        <div className={"col-9"}>
          <fieldset className="ns-fieldset">
            <div className={"ns-radios ns-radios--large"}>
              <div className="ns-radios__item">
                <input
                  className="ns-radios__input"
                  type={"radio"}
                  value={"corporation"}
                  onChange={(e) => {
                      setRoute(e.target.value);
                      setValidationError(false);
                  }}
                  checked={route === "corporation"}
                  id={"select-type-company-corporation-input"}
                  name={"select-type-company-corporation-input"}
                />
                <label
                  id={"select-type-company-corporation-label"}
                  className="ns-radios__label"
                  htmlFor={"select-type-company-corporation-input"}
                >
                  <span className="ns-label-span">
                    Corporation
                  </span>
                </label>
              </div>
              <div className="ns-radios__item">
                <input
                  className="ns-radios__input"
                  type={"radio"}
                  value={"partnership"}
                  onChange={(e) => {
                      setRoute(e.target.value);
                      setValidationError(false);
                  }}
                  checked={route === "partnership"}
                  id={"select-type-company-partnership-input"}
                  name={"select-type-company-partnership-input"}
                />
                <label
                  id={"select-type-company-partnership-label"}
                  className="ns-radios__label"
                  htmlFor={"select-type-company-partnership-input"}
                >
                  <span className="ns-label-span">
                    Partnership
                  </span>
                </label>
              </div>
              <div className="ns-radios__item">
                <input
                  className="ns-radios__input"
                  type={"radio"}
                  value={"soleProprietor"}
                  onChange={(e) => {
                      setRoute(e.target.value);
                      setValidationError(false);
                  }}
                  checked={route === "soleProprietor"}
                  id={"select-type-company-soleProprietor-input"}
                  name={"select-type-company-soleProprietor-input"}
                />
                <label
                  id={"select-type-company-soleProprietor-label"}
                  className="ns-radios__label"
                  htmlFor={"select-type-company-soloProprietor-input"}
                >
                  <span className="ns-label-span">
                    Sole Proprietor
                  </span>
                </label>
              </div>
            </div>
          </fieldset>
        </div>
      </div>

      {/* Continue */}
      <div className="row">
      <div className={"col-lg-4" + (validationError ? " has-error" : "")}>
          <Button
            className="ns-btn-yes-no"
            buttonType="regular_primary"
            onClick={handleContinue}
            text="Continue"
          />
          {validationError && ErrorMark()}
          {validationError && (
            <div className="ns-error-message">
              <span className="ns-visually-hidden">Error:</span>
              {"Please select a type of business before you continue"}
            </div>
          )}
        </div>
      </div>
    </div>
  );
};
